export default __webpack_public_path__ + "static/media/ri_percent-line.de00d419.svg";